import { buildPickemGroupPath } from "pages/PageConfigs";
import { GroupMembership } from "./GroupsList";
import { GroupItemContainer, GroupName, MembershipStatus } from "./styles";
import { PlainNavLink } from "styles/elements";

interface Props {
  groupMembership: GroupMembership;
}

export const GroupsListItem = ({ groupMembership }: Props) => {
  return (
    <PlainNavLink to={buildPickemGroupPath(groupMembership.groupId)}>
      <GroupItemContainer>
        <GroupName>{groupMembership.groupName}</GroupName>
        <MembershipStatus>{groupMembership.membership}</MembershipStatus>
      </GroupItemContainer>
    </PlainNavLink>
  );
};
